class PageSidebar extends HTMLElement {
  connectedCallback() {
    this.scrollOffset = parseInt(this.dataset.scrollOffset, 10) || 0;
    this.headerSelector = this.dataset.headerSelector || 'header[role="banner"], .header-wrapper, .header, #primary-navigation, header-component';
    this.addEventListener('click', this.onClick);
    this.updateHeaderHeightVar();
    window.addEventListener('resize', this.updateHeaderHeightVar, { passive: true });
    this.handleInitialHash();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    window.removeEventListener('resize', this.updateHeaderHeightVar);
  }

  onClick = (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) return;
    const link = event.target.closest('a[href*="#"]');
    if (!link) return;
    let url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (_) {
      return;
    }
    if (url.origin !== window.location.origin) return;
    if (url.pathname !== window.location.pathname) return;
    if (!url.hash || url.hash === '#') return;
    let target;
    try {
      target = document.querySelector(url.hash);
    } catch (_) {
      return;
    }
    if (!target) return;
    event.preventDefault();
    this.scrollToTarget(target);
    if (history.replaceState) history.replaceState(null, '', url.hash);
  };

  scrollToTarget = (target) => {
    const offset = this.getHeaderHeight() + this.scrollOffset;
    const top = target.getBoundingClientRect().top + window.scrollY - offset;
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top, behavior: prefersReduced ? 'auto' : 'smooth' });
  };

  handleInitialHash = () => {
    if (!window.location.hash) return;
    requestAnimationFrame(() => {
      let target;
      try {
        target = document.querySelector(window.location.hash);
      } catch (_) {
        return;
      }
      if (target) this.scrollToTarget(target);
    });
  };

  getHeaderHeight = () => {
    const header = document.querySelector(this.headerSelector);
    return header ? header.getBoundingClientRect().height : 0;
  };

  updateHeaderHeightVar = () => {
    this.style.setProperty('--header-height', `${this.getHeaderHeight()}px`);
  };
}

if (!customElements.get('page-sidebar')) {
  customElements.define('page-sidebar', PageSidebar);
}
